/////////////UserStateManager.ts
import axiosInstance from "../Datas/AxiosConfig";
import axios from "axios";

// მომხმარებლის ინტერფეისი 
export interface User {
  external_Id: string;
  first_name: string;
  profile_img: string;
  user_type: string;
  email: string;
}

// მინდინარე მომხმარებლის ცვლილებებზე მიმყოლების ტიპი
type UserChangeListener = (user: User | null) => void;

// სინგლტონი კლასი მომხმარებლის მდგომარეობის მართვისთვის
class UserStateManager {
  private static instance: UserStateManager;
  private listeners: UserChangeListener[] = [];
  private tokenCheckIntervalId: number | null = null;

  private constructor() {
    // ვუსმენთ localStorage-ში ცვლილებებს
    // (user ობიექტის გადატანა სხვა ტაბზე, თუმცა ტოკენები cookies-შია)
    window.addEventListener("storage", this.handleStorageChange);
  }

  // სინგლტონის მიღების მეთოდი
  public static getInstance(): UserStateManager {
    if (!UserStateManager.instance) {
      UserStateManager.instance = new UserStateManager();
    }
    return UserStateManager.instance;
  }

  // მომხმარებლის დამახსოვრება
  public setUser(user: User): void {
    localStorage.setItem("user", JSON.stringify(user));
    this.notifyListeners(user);

    // ავტომატურად დავიწყოთ ტოკენის ვალიდაციის შემოწმება
    this.startTokenValidationCheck();
  }

  // ტოკენის ვალიდურობის პერიოდული შემოწმების დაწყება
  public startTokenValidationCheck(): void {
    // თუ უკვე გაშვებულია, დავასრულოთ ძველი ინტერვალი
    if (this.tokenCheckIntervalId !== null) {
      this.stopTokenValidationCheck();
    }

    // შევამოწმოთ მომხმარებლის ტიპი
    const currentUser = this.getCurrentUser();

    // თუ Google-ის მომხმარებელია, არ ვიწყებთ ტოკენის შემოწმებას
    if (currentUser?.user_type === "clientOfGoogle") {
      return; // Google მომხმარებლებისთვის არ ვიწყებთ ინტერვალს
    }

    // მხოლოდ JWT მომხმარებლებისთვის ვიწყებთ ინტერვალს
    // this.tokenCheckIntervalId = window.setInterval(() => {
    //   this.checkAuthStatus();
    // }, 50 * 1000);

    ///////////
      // Access Token: 30 წუთი → შემოწმება: 15 წუთში ერთხელ
    this.tokenCheckIntervalId = window.setInterval(() => {
      this.checkAuthStatus();
    }, 60 * 60 * 1000); // შემმოწმება ყოველ 1 საათში
    /////////

    // პირველი შემოწმება დაუყოვნებლივ
    this.checkAuthStatus();
  }

  // შემოწმების გაჩერება
  public stopTokenValidationCheck(): void {
    if (this.tokenCheckIntervalId !== null) {
      window.clearInterval(this.tokenCheckIntervalId);
      this.tokenCheckIntervalId = null;
    }
  }

  // ავთენტიფიკაციის სტატუსის შემოწმება
  // checkAuthStatus მეთოდში დავამატოთ ტოკენის განახლების ლოგიკა
  public async checkAuthStatus(): Promise<boolean> {
    try {
      // ჯერ შევამოწმოთ მიმდინარე მომხმარებელი
      const currentUser = this.getCurrentUser();

      // თუ მომხმარებელი Google-ისაა, არ ვახდენთ JWT ტოკენების შემოწმებას
      if (currentUser?.user_type === "clientOfGoogle") {
        // Google-ის მომხმარებლისთვის უბრალოდ ვაბრუნებთ true-ს
        // ან შეგიძლიათ შეამოწმოთ AppWrite-ის სესია
        return true;
      }

      // თუ მომხმარებელი Facebook-ისაა, არ ვახდენთ JWT ტოკენების შემოწმებას
if (currentUser?.user_type === "clientOfFacebook") {
  // Facebook-ის მომხმარებლისთვის ვაბრუნებთ true-ს
  return true;
}

      // JWT მომხმარებლებისთვის ჩვეულებრივი შემოწმება
      const response = await axiosInstance.get("check-auth/");

      if (response.data.isAuthenticated) {
        // თუ საჭიროა ტოკენის განახლება
        if (response.data.needsRefresh) {
          try {
            // ვანახლებთ ტოკენს
            await axiosInstance.post("token/refresh/");
          } catch (refreshError) {
            console.error(
              "Token refresh during auth check failed:",
              refreshError
            );
            // განახლების შეცდომა არ ნიშნავს, რომ მომხმარებელი უნდა გავასუფთაოთ
            // უბრალოდ ვაღიარებთ შეცდომას, მაგრამ ვაგრძელებთ
          }
        }

        // თუ localStorage-ში არაა ან განსხვავდება, განვაახლოთ
        if (
          !currentUser ||
          currentUser.external_Id !== response.data.external_Id
        ) {
          const updatedUser: User = {
            external_Id: response.data.external_Id,
            first_name: response.data.first_name,
            profile_img: response.data.profile_img || "", // დეფოლტი ცარიელი
            user_type: response.data.user_type,
            email: response.data.email || "", // დეფოლტი ცარიელი
          };

          this.setUser(updatedUser);
        }

        return true;
      } else {
        // თუ სერვერზე არ არის ავთენტიფიცირებული, გავასუფთაოთ
        this.clearUser();
        return false;
      }
    } catch (error) {
      console.error("Auth check failed:", error);

      const currentUser = this.getCurrentUser();

      // Google-ის მომხმარებლისთვის შეცდომები არ ნიშნავს გასუფთავებას
      if (currentUser?.user_type === "clientOfGoogle") {
        return true;
      }

      // Facebook-ის მომხმარებლისთვის შეცდომები არ ნიშნავს გასუფთავებას
if (currentUser?.user_type === "clientOfFacebook") {
  return true;
}

      // თუ შეცდომის სტატუსი არის 401, ესეიგი ავთენტიფიკაცია არ გაიარა
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        await this.clearUser();
        return false;
      }

      return currentUser !== null;
    }
  }

  // მომხმარებლის გასუფთავება
  public async clearUser(): Promise<void> {
    const currentUser = this.getCurrentUser();

    // ჯერ გავაჩეროთ ტოკენის შემოწმების ინტერვალი
    this.stopTokenValidationCheck();

    // Google-ის მომხმარებლისთვის AppWrite-ის logout
    if (currentUser?.user_type === "clientOfGoogle") {
      try {
        // AppWrite-ის logout ფუნქციის იმპორტი და გამოძახება
        const { logout: appWriteLogout } = await import("./AppWrite");
        await appWriteLogout();
      } catch (error) {
        console.error("AppWrite logout failed:", error);
      }
    } else {
      // JWT მომხმარებლისთვის Django logout
      try {
        await axiosInstance.post("logout/");
      } catch (error) {
        console.error("Django logout API failed:", error);
      }
    }

    // ლოკალური მონაცემების გასუფთავება
    localStorage.removeItem("user");

    // მიმყოლების შეტყობინება
    this.notifyListeners(null);
  }

  // მიმდინარე მომხმარებლის მიღება
  public getCurrentUser(): User | null {
    const userString = localStorage.getItem("user");
    if (!userString) return null;

    try {
      return JSON.parse(userString) as User;
    } catch (error) {
      console.error("Error parsing user from localStorage", error);
      return null;
    }
  }

  // მიმყოლის დამატება
  public addListener(listener: UserChangeListener): void {
    this.listeners.push(listener);
  }

  // მიმყოლის წაშლა
  public removeListener(listener: UserChangeListener): void {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  // localStorage-ის ცვლილებების დამუშავება
  private handleStorageChange = (event: StorageEvent): void => {
    if (event.key === "user") {
      const user = event.newValue ? (JSON.parse(event.newValue) as User) : null;
      this.notifyListeners(user);
    }
  };

  // ყველა მიმყოლის შეტყობინება
  private notifyListeners(user: User | null): void {
    this.listeners.forEach((listener) => listener(user));
  }
}

// ექსპორტი
export default UserStateManager.getInstance();



